module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_99.0e24fe97.jpg";